import * as React from "react";

export default function Event({ event }: { event: ICTEvent }) {
  return (
    <div className="upcoming-events-container">
      <div className="col-xs-2">
        <div className="events-date-box">
          <div className="events-date-month">{event.month}</div>
          <div className="events-date-day">{event.day}</div>
        </div>
      </div>
      <div className="col-xs-10">
        <h3 className="events-title">
          <a href={event.url} target={"_blank"}  rel="noopener noreferrer" >
            {event.summary}
          </a>
        </h3>
        <div className="events-time">{event.timeSpan}</div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/home/Event.tsx